module.exports = __webpack_public_path__ + "static/img/title_06.42bc228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/title_06.png
// module id = xu4J
// module chunks = 1